﻿'use strict'

import * as Backbone from 'backbone';
import config from '../../common/config';

export default (function () {
    var API = {
        signalR_init : function() {
            
            var url = config.signalRUrl() + '/signalr';

            var connection = new signalR.HubConnectionBuilder().withUrl("/E4UsHub?User=" + config.authUserId()).withAutomaticReconnect([0, 0, 10000]).build();

            connection.on("ReceiveMessage", function (message) {
                var message_event_str = message.substring(0, message.indexOf("#¤%&/()=?"));
                var message_event = parseInt(message_event_str);
                var correct_message = message.substring(message.indexOf("#¤%&/()=?") + "#¤%&/()=?".length, message.length);
                
                //if (correct_message == 'SCREENSHOT_REFRESH') {
                    var customEvent = app.entities.collections.customEvent.fullCollection.where({ id: message_event })[0];
                    customEvent.attributes.WebpageImageUrl = correct_message;
                        
                    var userChannel = Backbone.Radio.channel('app');
                    userChannel.trigger('screenShot:update');
                //} 
                
            });

            connection.onreconnecting(error => {
                console.assert(connection.state === signalR.HubConnectionState.Reconnecting);

                document.getElementById("messageInput").disabled = true;

                const li = document.createElement("li");
                li.textContent = 'Connection lost due to error "${error}". Reconnecting.';
                document.getElementById("messageList").appendChild(li);
            });

            connection.onreconnected(connectionId => {
                console.assert(connection.state === signalR.HubConnectionState.Connected);

                document.getElementById("messageInput").disabled = false;

                const li = document.createElement("li");
                li.textContent = 'Connection reestablished. Connected with connectionId "${connectionId}".';
                document.getElementById("messageList").appendChild(li);
            });

            async function start() {
                try {
                    await connection.start();
                    console.assert(connection.state === signalR.HubConnectionState.Connected);
                    console.log("SignalR Connected.");
                } catch (err) {
                    console.assert(connection.state === signalR.HubConnectionState.Disconnected);
                    console.log(err);
                    setTimeout(() => start(), 5000);
                }
            };

            connection.onclose(error => {
                console.assert(connection.state === signalR.HubConnectionState.Disconnected);

                document.getElementById("messageInput").disabled = true;

                const li = document.createElement("li");
                li.textContent = 'Connection closed due to error "${error}". Try refreshing this page to restart the connection.';
                document.getElementById("messageList").appendChild(li);

                start();
            });
        
            //$.connection.hub.start( {withCredentials: false}).done(function () {
            //    //hub.server.hello();
            //    var a = 0;
            //});

            //$.connection.hub.disconnected(function () {
            //    setTimeout(function () {
            //        $.connection.hub.start();
            //    }, 5000); // Restart connection after 5 seconds.
            //});

            connection.start().catch(function (err) {
                return console.error(err.toString());
            });
        },
        
    };

    return API;
})();
